import {initialAdminTicketsState, ITicketsState, IUserTicket} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getAdminTickets, getTicketsForUser, obtainEntries, obtainFreeVoucher} from "./ActionCreators";
import {IAdminTicketsResponse} from "../../api/ticketService";

const initialValue: ITicketsState = {
    loading: false,
    fetchLoading: false,
    userTickets: [],
    adminTickets: initialAdminTicketsState,
    adminTicketsLoading: false,
}


const ticketSlice = createSlice({
    name: SliceNames.TICKET,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            obtainEntries.pending, (state) => {
                state.loading = true
            })
            .addCase(
                obtainEntries.fulfilled, (state) => {
                    state.loading = false
                })
            .addCase(
                obtainEntries.rejected, (state) => {
                    state.loading = false
                })
            .addCase(
                obtainFreeVoucher.pending, (state) => {
                    state.loading = true
                })
            .addCase(
                obtainFreeVoucher.fulfilled, (state) => {
                    state.loading = false
                })
            .addCase(
                obtainFreeVoucher.rejected, (state) => {
                    state.loading = false
                })
            .addCase(
                getTicketsForUser.pending, (state) => {
                    state.fetchLoading = true
                })
            .addCase(
                getTicketsForUser.fulfilled, (state, action: PayloadAction<IUserTicket[]>) => {
                    state.fetchLoading = false
                    state.userTickets = action.payload
                })
            .addCase(
                getTicketsForUser.rejected, (state) => {
                    state.userTickets = []
                    state.fetchLoading = false
                })
            .addCase(
                getAdminTickets.pending, (state) => {
                    state.adminTicketsLoading = true
                })
            .addCase(
                getAdminTickets.fulfilled, (state, action: PayloadAction<IAdminTicketsResponse>) => {
                    state.adminTickets = action.payload
                    state.adminTicketsLoading = false
                })
            .addCase(
                getAdminTickets.rejected, (state) => {
                    state.adminTickets = initialAdminTicketsState
                    state.adminTicketsLoading = false
                })
    }
})

export default ticketSlice.reducer
